import React from 'react';
import { Building2, HeartHandshake, Sparkles, UsersRound } from 'lucide-react';
import { FadeIn } from './FadeIn';
const AUDIENCES = [{
  label: 'Retreats & workshops',
  icon: Sparkles
}, {
  label: 'Yoga & breathwork groups',
  icon: HeartHandshake
}, {
  label: 'Private gatherings',
  icon: UsersRound
}, {
  label: 'Team & corporate days',
  icon: Building2
}];
const SPACE_FEATURES = ['Geodesic dome', 'Wood-fired sauna', 'Cedar hot tub', 'Cold plunges', 'Swimming pool', 'Outdoor kitchen', 'Fire pit', 'Overnight accommodation'];
export function RetreatSpaceDetails() {
  return <section className="bg-cream px-6 py-20 md:px-12 md:py-32" data-id="element-211" data-mp="2nhjoqi9k7few">
      <div className="mx-auto max-w-6xl" data-id="element-212" data-mp="2nj4kgb7m14ec">
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-2 lg:gap-24" data-id="element-213" data-mp="2rjeohibudkqk">
          <div data-id="element-214" data-mp="lpojolht695n">
            <FadeIn data-id="element-215" data-mp="lp5apua4yv3r">
              <p className="mb-4 text-xs font-medium uppercase tracking-[0.2em] text-clay/70" data-id="element-216" data-mp="lqq1d8tbxtwc">
                Perfect for
              </p>
            </FadeIn>
            <FadeIn delay={0.1} data-id="element-217" data-mp="21x3jgskoe476">
              <h2 className="mb-8 font-serif text-4xl leading-tight text-pine md:text-5xl" data-id="element-218" data-mp="21wajcag82cy0">
                Meaningful experiences need a place that can hold them.
              </h2>
            </FadeIn>
            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2" data-id="element-219" data-mp="2bmvh5vo2ndfv">
              {AUDIENCES.map((audience, index) => {
              const Icon = audience.icon;
              return <FadeIn key={audience.label} delay={index * 0.07} data-id="element-220" data-mp="1izivdnpqj9nm" data-mpi={index}>
                    <div className="flex min-h-28 flex-col justify-between rounded-sm border border-pine/15 bg-creamDeep p-5" data-id="element-221" data-mp="1e066yyj7tuix">
                      <Icon className="h-5 w-5 text-ember" data-id="element-222" data-mp="1sxoszt4idtmo" />
                      <p className="font-medium text-pine" data-id="element-223" data-mp="1ny3ufjt93nah">{audience.label}</p>
                    </div>
                  </FadeIn>;
            })}
            </div>
          </div>

          <div data-id="element-224" data-mp="2zd9b5rq7vmd3">
            <FadeIn data-id="element-225" data-mp="2zdsikei8qscv">
              <p className="mb-4 text-xs font-medium uppercase tracking-[0.2em] text-clay/70" data-id="element-226" data-mp="2zc7mgkga31cw">
                The space includes
              </p>
            </FadeIn>
            <FadeIn delay={0.1} data-id="element-227" data-mp="3ber3ssbl2f47">
              <div className="border-t border-pine/15" data-id="element-228" data-mp="3bdz5vauik5ar">
                {SPACE_FEATURES.map((feature, index) => <div key={feature} className="flex items-center justify-between border-b border-pine/15 py-4" data-id="element-229" data-mp="3gf505d3to0me" data-mpi={index}>
                    <span className="text-lg font-light text-clay" data-id="element-230" data-mp="3lb3wpnzb0oxw">{feature}</span>
                    <span className="h-1.5 w-1.5 rounded-full bg-ember" data-id="element-231" data-mp="2nriy49a8t41n" />
                  </div>)}
              </div>
            </FadeIn>
            <FadeIn delay={0.2} data-id="element-232" data-mp="2xncc7x3m15lj">
              <p className="mt-7 text-sm font-light leading-relaxed text-clay/70" data-id="element-233" data-mp="2xmayfkv7m504">
                [Replace with capacity, day-use terms, and any equipment or facilitation details when confirmed.]
              </p>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}